import React, { Component } from 'react';
import { Heading1, StackView, Text } from 'localmed-core';

import style from './AppointmentFormPage.scss';

import TrackClick from '../../../shared/components/TrackClick';

class AppointmentVerifyPage extends Component {
  render() {
    const { provider, email } = this.props;

    return (
      <StackView spacing="sm">
        <Heading1 fontWeight="bold" className={style['appointment-form-page__title']}>
          <strong>Important:</strong> We can&apos;t confirm your appointment until you verify your
          email.
        </Heading1>

        <Text fontSize="lg" data-qa="appointment-form__verification-message">
          Please check <strong>{email}</strong> and click on the verification link from
          noreply@localmed.com to complete your booking with {provider.display}.
        </Text>

        <div className={style['appointment-form-page__links']}>
          <TrackClick
            event="Clicked Email Inbox Link"
            eventProperties={{ component: 'AppointmentVerifyPage', inboxType: 'Gmail' }}
          >
            {(getTrackingProps) => (
              <a
                href="https://mail.google.com"
                rel="noopener noreferrer"
                target="_blank"
                {...getTrackingProps()}
              >
                Gmail
              </a>
            )}
          </TrackClick>
          <TrackClick
            event="Clicked Email Inbox Link"
            eventProperties={{ component: 'AppointmentVerifyPage', inboxType: 'iOS Mail' }}
          >
            {(getTrackingProps) => (
              <a
                href="message://"
                rel="noopener noreferrer"
                target="_blank"
                {...getTrackingProps()}
              >
                iOS Mail
              </a>
            )}
          </TrackClick>
          <TrackClick
            event="Clicked Email Inbox Link"
            eventProperties={{ component: 'AppointmentVerifyPage', inboxType: 'Outlook' }}
          >
            {(getTrackingProps) => (
              <a
                href="https://outlook.com"
                rel="noopener noreferrer"
                target="_blank"
                {...getTrackingProps()}
              >
                Outlook.com
              </a>
            )}
          </TrackClick>
          <TrackClick
            event="Clicked Email Inbox Link"
            eventProperties={{ component: 'AppointmentVerifyPage', inboxType: 'Yahoo' }}
          >
            {(getTrackingProps) => (
              <a
                href="https://mail.yahoo.com"
                rel="noopener noreferrer"
                target="_blank"
                {...getTrackingProps()}
              >
                Yahoo! Mail
              </a>
            )}
          </TrackClick>
          <TrackClick
            event="Clicked Email Inbox Link"
            eventProperties={{ component: 'AppointmentVerifyPage', inboxType: 'AOL' }}
          >
            {(getTrackingProps) => (
              <a
                href="https://mail.aol.com"
                rel="noopener noreferrer"
                target="_blank"
                {...getTrackingProps()}
              >
                AOL Mail
              </a>
            )}
          </TrackClick>
          <TrackClick
            event="Clicked Email Inbox Link"
            eventProperties={{ component: 'AppointmentVerifyPage', inboxType: 'Other' }}
          >
            {(getTrackingProps) => (
              <a
                href="message://"
                rel="noopener noreferrer"
                target="_blank"
                {...getTrackingProps()}
              >
                Other
              </a>
            )}
          </TrackClick>
        </div>

        <Text fontSize="xs">
          Please check your Spam folder if you have not received the email in 5 minutes. This link
          will expire in one hour from the time it was generated so please check promptly.
        </Text>

        <Text fontSize="xs">
          <i>
            Note: adding noreply@localmed.com to your safe sender list or your address book ensures
            you receive all the important communications from LocalMed.
          </i>
        </Text>
      </StackView>
    );
  }
}

export default AppointmentVerifyPage;
